// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CreditCardIconSignature {
  Element: SVGSVGElement;
}

export const CreditCardIcon: TOC<CreditCardIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 4H20C21.104 4 22 4.898 22 6V18C22 19.103 21.104 20 20 20H4C2.896 20 2 19.103 2 18V6C2 4.898 2.896 4 4 4ZM19.999 9L20 6H4V9H19.999ZM4 18V11H19.999L19.997 18H4ZM19 12H15V14H19V12ZM5 12H12V14H5V12ZM10 15H5V17H10V15Z"/>
</svg>
</template>;